import React, { useState, useEffect } from 'react';
import { useNavigate } from "react-router-dom";
import { Select, Button, Group, Text, Accordion, Input, Space } from '@mantine/core';
import { IconX } from '@tabler/icons-react';
import { notifications } from '@mantine/notifications';
import { SelectFunnelList, HelpTip } from "../../components/GeneralComponent/GeneralComponent";
import CampaignApi from "../../api/CampaignApi";
import classes from '../../pages/DashBoard/DashBoard.module.css';

export function Step1({ selectedMemberWebsite, campaignId, setCampaignId, campaign_id, SelectedFunnelValue, setSelectedFunnelValue, campaignLPPageValue, setCampaignLPPage, campaignName, setCampaignName, step1Disabled, step1FieldDisabled, setStep3Disabled, setStep4Disabled, setStepValue, campaignLoader }:any) {
  const navigate = useNavigate();
  const [campaignLPPageList, setCampaignLPPageList] = useState([]);

  const handleSelectFunnelListComponentChange = (Value:any) => {
    if(Value !== ""){
      campaignLoader(true);
      CampaignApi.checkexistingcampaign({
        funnel_id : Value,
        c_id : campaignId || campaign_id
      })
      .then(response => {
        if (response.ok) {
          return response.json();
        } else {
          if (response.status === 401 || response.status === 400) {
            campaignLoader(false);
            navigate("/logout");
          }
        }
      })
      .then(data => {
        if(data.status === 1){
          setSelectedFunnelValue(Value);
        }else{
          notifications.show({
            color: 'red',
            icon: <IconX size="1.1rem" />,
            title: 'Error',
            message: data.message,
          });
        }
        campaignLoader(false);
      })
      .catch(error => {
        console.log(error);
        campaignLoader(false);
      });
    }
  };

  useEffect(() => {
    if(SelectedFunnelValue !== null && selectedMemberWebsite !== ""){      
      campaignLoader(true);
      CampaignApi.getcampaignpagebyfunnelid({
        funnel_id : SelectedFunnelValue,
        system_website_id : selectedMemberWebsite
      })
      .then(response => {
        if (response.ok) {
          return response.json();
        } else {
          if (response.status === 401 || response.status === 400) {
            campaignLoader(false);
            navigate("/logout");
          }
        }
      })
      .then(data => {
        if(data.status === 1 && data.data && data.data.length > 0){
          setCampaignLPPageList(data.data);
          // setCampaignLPPage('');
        }else{
          setCampaignLPPageList([]);
        }
        campaignLoader(false);
      })
      .catch(error => {
        console.log(error);
        campaignLoader(false);
      });
    }
  }, [SelectedFunnelValue, selectedMemberWebsite, navigate]);

  const handleCampaignLPPageChange = (value:any) => {
    if(value !== ""){
      campaignLoader(true);
      CampaignApi.checkexistingcampaignpage({
        campaign_page_id : value,
        c_id : campaignId || campaign_id
      })
      .then(response => {
        if (response.ok) {
          return response.json();
        } else {
          if (response.status === 401 || response.status === 400) {
            campaignLoader(false);
            navigate("/logout");
          }
        }
      })
      .then(data => {
        if(data.status === 1){
          setCampaignLPPage(value);
        }else{
          notifications.show({
            color: 'red',
            icon: <IconX size="1.1rem" />,
            title: 'Error',
            message: data.message,
          });
        }
        campaignLoader(false);
      })
      .catch(error => {
        console.log(error);
        campaignLoader(false);
      });
    }
  }

  const submitStep1 = () => {
    if(SelectedFunnelValue === "" || SelectedFunnelValue === null){
      notifications.show({
        color: 'red',
        icon: <IconX size="1.1rem" />,
        title: 'Error',
        message: "Please Select a Funnel",
      });
    }else if(campaignName === "" || campaignName === null){
      notifications.show({
        color: 'red',
        icon: <IconX size="1.1rem" />,
        title: 'Error',
        message: "Please Enter Campaign Name",
      });
    }else if(campaignLPPageValue === "" || campaignLPPageValue === null){
      notifications.show({
        color: 'red',
        icon: <IconX size="1.1rem" />,
        title: 'Error',
        message: "Please Select Campaign Page",
      });
    }else{
      campaignLoader(true);
      CampaignApi.addcampaignstepfirst({
        funnel_id : SelectedFunnelValue,
        campaign_name : campaignName,
        campaign_page_id : campaignLPPageValue,
        system_website_id : selectedMemberWebsite,
        c_id : campaign_id || campaignId
      })
      .then(response => {
        if (response.ok) {
          return response.json();
        } else {
          if (response.status === 401 || response.status === 400) {
            campaignLoader(false);
            navigate("/logout");
          }
        }
      })
      .then(data => {
        if(data.status === 1){
          if (document.activeElement instanceof HTMLElement) {
            document.activeElement.blur();
          }
          setStep4Disabled(false);
          setStepValue('step-3');
          setCampaignId(data.data.campaign_id);
        }else{
          notifications.show({
            color: 'red',
            icon: <IconX size="1.1rem" />,
            title: 'Error',
            message: data.message,
          });
        }
        campaignLoader(false);
      })
      .catch(error => {
        console.log(error);
        campaignLoader(false);
      });
    }
  };


  return (
    <>
      <Accordion.Item className={classes.item} value="step-1">
        <Accordion.Control disabled={step1Disabled}><Text component="span" color="red" weight={500}>Step 1</Text><Text component="span" weight={500}> - Select Campaign Page </Text><HelpTip helpId={313} /></Accordion.Control>
        <Accordion.Panel>
          <Group spacing="xs" mb={5}>
            <Text mr={20} weight={500}>Select a Funnel:</Text>
            {step1FieldDisabled === true ? (
              <SelectFunnelList 
                updated_time={0} 
                Value={SelectedFunnelValue} 
                OnChange={handleSelectFunnelListComponentChange} 
                MemberWebsiteId={selectedMemberWebsite} 
                Width={250} 
                IsSelected={false}
                IsFieldDisabled={true}
              />
            ) : ( 
              <SelectFunnelList 
                updated_time={0} 
                Value={SelectedFunnelValue} 
                OnChange={handleSelectFunnelListComponentChange} 
                MemberWebsiteId={selectedMemberWebsite} 
                Width={250} 
                IsSelected={false}
                IsFieldDisabled={false}
              />
            )}
          </Group>
          <Group spacing="xs" mb={5}>
            <Text mr={10} weight={500}>Campaign Name:</Text>
            <Input w={250} value={campaignName} onChange={(e) => setCampaignName(e.target.value)}/>
          </Group>
          <Group spacing="xs" mb={5}>
            <Text mr={17} weight={500}>Campaign Page:</Text>
            {step1FieldDisabled === true ? (
              <Select
                data={campaignLPPageList.map(page => ({
                  value: page.page_id,
                  label: page.title
                }))}
                value={campaignLPPageValue}
                name="landing_page"
                onChange={handleCampaignLPPageChange}
                w={250}
                placeholder="Select Campaign Page"
                disabled={true}
              />
            ) : (
              <Select
                data={campaignLPPageList.map(page => ({
                  value: page.page_id,
                  label: page.title
                }))}
                value={campaignLPPageValue}
                name="landing_page"
                onChange={handleCampaignLPPageChange}
                w={250}
                placeholder="Select Campaign Page"
              />
            )}
          </Group>
          <Text weight={500}>All goal calculations will be based upon unique visits to this page.</Text>
          <Space h="md" />
          <Text weight={500}>For example: Conversion rates are calculated by dividing the number of conversions (actions) by the total number of uniques. Conversions / Uniques</Text>
          <Space h="md" />
          <Text weight={500}>The most common choice is the first page in your funnel but there are times when you want to choose a different page in your funnel for these calculations.</Text>
          <Button type="button" mt={10} onClick={() => submitStep1()}>Continue</Button>
        </Accordion.Panel>
      </Accordion.Item>
    </>
  );
}